import { Pipe, PipeTransform } from '@angular/core';
import { TransactionTerminologyKey, TransactionTerminologyService } from '../../core/services/transaction-terminology.service';

@Pipe({
  name: 'term',
  pure: false,
})
export class TransactionTerminologyPipe implements PipeTransform {
  constructor(private terminology: TransactionTerminologyService) {}

  transform(value: TransactionTerminologyKey): string {
    return this.terminology.label(value);
  }
}